import React from "react";
import qs from "query-string";
import PropTypes from "prop-types";
//import moment from 'moment';

import { arrangeData } from "components/list/action/action-util";
//import Link from 'next/link';
import View from "components/list/view/View";
import { autobind } from "react-decoration";
import rr from "lib/ResourceRelated";
import ListCateComp2 from "components/resource/ListCateComp2";
import ReactHtmlParser from "react-html-parser";
import navigate from "lib/navigate";
import Link from "lib/Link";

class DBDisplayComp2 extends View {
  constructor(props) {
    super(props);

    this.state = {
      urlCopied: false,
      hasPic: true,
    };
  }

  @autobind
  toResource(resource, e) {
    e.preventDefault();
    let { search } = this.props;
    let params = { ...search };
    let filterField = params.filterField || [];
    let filterValue = params.filterValue || [];
    filterField.push("source");
    filterValue.push(resource);
    params.filterField = filterField;
    params.filterValue = filterValue;
    navigate(["/resourceList", qs.stringify(params)].join("?"));
  }

  @autobind
  getDisplayDataByField(display = [], fieldName = "") {
    let seqIndex = display
      .map(function (display) {
        return display.field;
      })
      .indexOf(fieldName);
    return display[seqIndex] || {};
  }

  @autobind
  toURL(url, target, e) {
    e.preventDefault();
    window.open(url, target);
  }

  @autobind
  urlToClipboard(url, e) {
    e.preventDefault();
    navigator.clipboard.writeText(url);
    this.setState({ urlCopied: true });
    setTimeout(() => {
      return this.setState({ urlCopied: false });
    }, 3000);
  }

  render() {
    let {
      data,
      resourceData,
      rowStyle,
      serialNo,
      handleClick,
      i18n,
      t,
      info,
      refetch,
      displayConfig,
      appStore,
    } = this.props;

    let { globalConfig } = appStore;

    const arrangedData = arrangeData(data);

    const { id, ebname, en_ebname, pic = "" } = arrangedData;

    let { hasPic } = this.state;

    let { language } = i18n;

    let maxIntroLen = 50;
    let urlData = resourceData.dbURLList;
    let attachData = resourceData.dbAttachList;
    let {
      userCollectionList,
      journalCollect = "",
      ermEJournal = "",
      ermProcLink = "",
    } = info || [];
    let isMaintain = resourceData.isMaintain;
    let isMaintainShow = resourceData.isMaintainShow;
    let joCount = resourceData.joCount || 0;
    let ebookCount = resourceData.ebookCount || 0;
    let title = "";
    if (language === "zh") {
      title = ebname;
    } else if (
      language === "en" &&
      en_ebname !== undefined &&
      en_ebname !== null
    ) {
      title = en_ebname;
    } else {
      title = ebname;
    }
    return (
      <>
        <li className={rowStyle}>
          <span className="order">{serialNo}</span>
          <div className="title">
            <a
              tabIndex="0"
              href="javascript:;"
              className="showLightbox"
              title={t("jumperrwd.common.openLightBoxByName", {
                name: ReactHtmlParser(title),
              })}
              onClick={(e) => {
                e.preventDefault();
                handleClick({ id });
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleClick({ id });
                }
              }}>
              {ReactHtmlParser(title)}
            </a>
            {isMaintain && (
              <span className="status">{t("hyint.esource.maintain")}</span>
            )}
          </div>
          <dl>
            {data.map((item, keys) => {
              let outTemp = [];
              let fieldConfig = this.getDisplayDataByField(
                displayConfig,
                item.key
              );
              if (item.key === "journal_url") {
                let journalURLTemp = [];
                if (
                  (journalCollect === "" ||
                    journalCollect === "0" ||
                    journalCollect === "1") &&
                  item.value !== ""
                ) {
                  journalURLTemp.push(
                    <li>
                      <div className="title">
                        {t("jumperrwd.eb_basic_extension.name." + item.key)}：
                      </div>
                      <Link
                        href={item.value}
                        title={
                          ReactHtmlParser(title) +
                          "-" +
                          this.props.t("jumper.common.listview")
                        }
                        target="_blank"
                        rel="noopener noreferrer">
                        {this.props.t("jumper.common.listview")}
                      </Link>
                    </li>
                  );
                }
                if (
                  journalCollect === "" ||
                  journalCollect === "0" ||
                  journalCollect === "2"
                ) {
                  if (ermEJournal === "1") {
                    if (ermProcLink === "") {
                      if (joCount !== 0) {
                        journalURLTemp.push(
                          <li>
                            <div className="title">
                              {this.props.t("hyint.esource.collectjournal")}：
                            </div>
                            <Link
                              href={
                                "/resourceList?pageType=jo2db&resourceType=journal&dbID=" +
                                id
                              }
                              title={
                                ReactHtmlParser(title) +
                                "-" +
                                this.props.t("jumper.common.listview")
                              }>
                              {this.props.t("jumper.common.listview")}
                            </Link>
                          </li>
                        );
                      }
                    }
                  }
                  if (ebookCount !== 0) {
                    journalURLTemp.push(
                      <li>
                        <div className="title">
                          {this.props.t("hyint.esource.collectebook")}：
                        </div>
                        <Link
                          href={
                            "/resourceList?pageType=jo2db&resourceType=ebook&dbID=" +
                            id
                          }
                          title={
                            ReactHtmlParser(title) +
                            "-" +
                            this.props.t("jumper.common.listview")
                          }>
                          {this.props.t("jumper.common.listview")}
                        </Link>
                      </li>
                    );
                  }
                }
                return journalURLTemp;
              }
              if (
                item.key !== "ebname" &&
                item.key !== "en_ebname" &&
                item.key !== "journal_url" &&
                item.key !== "pic"
              ) {
                if (item.key === "intro" || item.key === "en_intro") {
                  if (
                    (item.key === "intro" && language === "zh") ||
                    (item.key === "en_intro" && language === "en")
                  ) {
                    let intro = item.value || "";
                    intro = rr.htmlRemoveTag(intro);
                    let len = intro.length;
                    let isShowMore = len > maxIntroLen ? true : false;
                    if (len > maxIntroLen) {
                      intro = rr.cutIntro(intro, maxIntroLen);
                    }
                    if (intro !== "") {
                      outTemp.push(intro);
                      if (isShowMore) {
                        outTemp.push(
                          <>
                            <a
                              tabIndex="0"
                              href="javascript:;"
                              title={t("jumperrwd.common.openLightBoxViewIntroByName", {
                                name: ReactHtmlParser(title),
                              })}
                              onClick={(e) => {
                                e.preventDefault();
                                handleClick({ id });
                              }}
                              onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                  handleClick({ id });
                                }
                              }}>
                              {"(" + t("jumper.common.table.detail") + ")"}
                            </a>
                          </>
                        );
                      }
                    }
                  }
                } else if (item.key === "url") {
                  if (!isMaintain || isMaintainShow) {
                    let urlShowType =
                      globalConfig["jumperrwd.resource.dbURLShowType"] || "";
                    if (urlShowType === "") {
                      urlShowType = "1";
                    }
                    let url = item.value;
                    if (urlShowType === "1") {
                      let urlShow = url;
                      if (urlShow.length > 50) {
                        urlShow = rr.cutIntro(urlShow, 50);
                      }
                      outTemp.push(
                        <Link
                          href={"/sendURLApiV3?dbid=" + id}
                          title={ReactHtmlParser(title) + "-網址連結"}
                          target="_blank"
                          rel="noopener noreferrer">
                          {urlShow}
                        </Link>
                      );
                    } else if (urlShowType === "2") {
                      let copyButtonName = "複製網址";
                      if (this.state.urlCopied) {
                        copyButtonName = "已複製";
                      }
                      outTemp.push(
                        <>
                          <button
                            type="button"
                            tabIndex="0"
                            title={ReactHtmlParser(title) + "-開啟連結"}
                            aria-label={ReactHtmlParser(title) + "-開啟連結"}
                            className="btn_normal"
                            onClick={this.toURL.bind(
                              this,
                              "/sendURLApiV3?dbid=" + id,
                              "_blank"
                            )}>
                            開啟連結
                          </button>
                          <button
                            type="button"
                            tabIndex="0"
                            title={ReactHtmlParser(title) + "-複製網址"}
                            aria-label={ReactHtmlParser(title) + "-複製網址"}
                            className="btn_normal"
                            onClick={this.urlToClipboard.bind(this, url)}>
                            {copyButtonName}
                          </button>
                        </>
                      );
                    }
                  }
                } else if (item.key === "funds") {
                  item.value.split(",").map((tmp, k) => {
                    if (k !== 0) {
                      outTemp.push(",");
                    }
                    let name = "jumperrwd.funds.name." + tmp;
                    outTemp.push(this.props.t(name));
                    return "";
                  });
                } else if (item.key === "note" || item.key === "en_note") {
                  if (
                    (item.key === "note" && language === "zh") ||
                    (item.key === "en_note" && language === "en")
                  ) {
                    let note = item.value;
                    /*
                        QueryBean Bean = new QueryBean();
                        Object[] Data = ResourceRelatedBean.getIsNote(rs.getString("c.id"),session.getAttribute("useUnitSN").toString(),session.getAttribute("Groupid_Val").toString());
                        boolean isNote = (Boolean) Data[1];	//取得是否顯示公告資訊
                      */
                    outTemp.push(ReactHtmlParser(note));
                  }
                } else if (item.key === "platform") {
                  let platforms = item.value.split(",");
                  let platformString = "";
                  platforms.map((platform_id, k) => {
                    if (k > 0) {
                      platformString += ", ";
                    }
                    platformString += t(
                      "jumperrwd.platform.name." + platform_id
                    );
                    return "";
                  });
                  outTemp.push(platformString);
                } else if (item.key === "browser") {
                  let browsers = item.value.split(",");
                  let browserString = "";
                  browsers.map((browser_id, k) => {
                    if (k > 0) {
                      browserString += ", ";
                    }
                    browserString += t("jumperrwd.browser.name." + browser_id);
                    return "";
                  });
                  outTemp.push(browserString);
                  /*let browser_flag = false;
                    item.value.split(",").map((browser_id) => {
                      let browser_icon = this.props.t(
                        "jumperrwd.browser.icon." + browser_id
                      );
                      if (
                        browser_icon !==
                          "jumperrwd.browser.icon." + browser_id &&
                        browser_icon !== ""
                      ) {
                        outTemp.push(
                          <>
                            <img
                              src={
                                imagesPath +
                                this.props.t(
                                  "jumperrwd.browser.icon." + browser_id
                                )
                              }
                              title={this.props.t(
                                "jumperrwd.browser.name." + browser_id
                              )}
                              alt={this.props.t(
                                "jumperrwd.browser.name." + browser_id
                              )}
                            />
                          </>
                        );
                      } else {
                        if (browser_flag) {
                          outTemp.push(", ");
                        }
                        outTemp.push(
                          this.props.t("jumperrwd.browser.name." + browser_id)
                        );
                        browser_flag = true;
                      }
                      return "";
                    });*/
                } else if (item.key === "eb_basic_url") {
                  if (
                    urlData !== undefined &&
                    urlData !== null &&
                    urlData.length !== 0
                  ) {
                    urlData.map((urld, k) => {
                      let showname =
                        urld.showName ||
                        "(" + t("jumperrwd.common.noName") + ")";
                      let attachpath = urld.url || "";
                      let openwin = urld.openWin || "0";
                      if (k !== 0) {
                        outTemp.push("、");
                      }
                      if (openwin === "1") {
                        outTemp.push(
                          <Link href={attachpath} title={showname}>
                            {showname}
                          </Link>
                        );
                      } else {
                        outTemp.push(
                          <>
                            <Link
                              href={attachpath}
                              title={showname}
                              target="_blank"
                              rel="noopener noreferrer">
                              {showname}
                            </Link>
                          </>
                        );
                      }
                      return "";
                    });
                  }
                } else if (item.key === "ebattach") {
                  if (attachData && attachData.length !== 0) {
                    attachData.map((attachd, k) => {
                      let showName =
                        attachd.showName || t("jumperrwd.common.file");
                      let attachPath = attachd.attachPath || "";
                      let fileTypePhoto,
                        fileType = rr.getFileTypePhoto(attachPath);

                      if (k !== 0) {
                        outTemp.push("、");
                      }

                      let ebattachTemp = [];
                      if (fileTypePhoto !== "") {
                        ebattachTemp.push(
                          <>
                            &nbsp;
                            <img
                              src={fileTypePhoto}
                              alt="檔案類型"
                              border="0"
                            />
                          </>
                        );
                      }
                      let downloadTitle = ReactHtmlParser(showName);
                      if (fileType !== "") {
                        downloadTitle += "(下載" + fileType + ")";
                      }
                      outTemp.push(
                        <>
                          <Link
                            href={"/file/downloadFile/" + attachPath}
                            title={downloadTitle}>
                            {ReactHtmlParser(showName)}
                            {ebattachTemp}
                          </Link>
                        </>
                      );
                      return "";
                    });
                  }
                } else if (item.key === "applicable") {
                  let applicables = item.value.split(",");
                  let applicableString = "";
                  applicables.map((applicable_sn, k) => {
                    if (k > 0) {
                      applicableString += ", ";
                    }
                    applicableString += t(
                      "jumperrwd.applicable.name." + applicable_sn
                    );
                    return "";
                  });
                  outTemp.push(applicableString);
                } else if (item.key === "language") {
                  outTemp.push(
                    this.props.t("jumperrwd.language.name." + item.value)
                  );
                } else if (item.key === "property") {
                  outTemp.push(
                    this.props.t("jumperrwd.property.name." + item.value)
                  );
                } else if (item.key === "source") {
                  if (
                    this.props.t("jumperrwd.source.name." + item.value) ===
                    "jumperrwd.source.name." + item.value
                  ) {
                    outTemp.push(item.value);
                  } else {
                    outTemp.push(
                      this.props.t("jumperrwd.source.name." + item.value)
                    );
                  }
                } else if (item.key === "connrange") {
                  outTemp.push(
                    this.props.t("jumperrwd.connrange.name." + item.value)
                  );
                } else if (item.key === "cooperation") {
                  outTemp.push(
                    this.props.t("jumperrwd.cooperation.name." + item.value)
                  );
                } else if (item.key === "publisher") {
                  outTemp.push(
                    this.props.t("jumperrwd.publisher.name." + item.value)
                  );
                } else if (item.key === "ezproxy") {
                  outTemp.push(this.props.t("jumperrwd.ezproxy." + item.value));
                } else if (item.key !== "id") {
                  if (fieldConfig.isUnEscape === "1") {
                    outTemp.push(ReactHtmlParser(item.value));
                  } else {
                    outTemp.push(item.value);
                  }
                }
              }
              if (outTemp.length > 0) {
                return (
                  <div>
                    <dt>
                      {t("jumperrwd.eb_basic_extension.name." + item.key)}
                    </dt>
                    <dd>{outTemp}</dd>
                  </div>
                );
              }
              return "";
            })}
          </dl>
          <ul className="popularity">
            <li>
              <ListCateComp2
                {...this.props}
                id={id}
                userCollectionList={userCollectionList}
                resourceType={"databases"}
                refetch={refetch}
              />
            </li>
          </ul>
          {pic !== "" && hasPic && (
            <img
              className="prim wide"
              src={"/file/downloadFile/" + pic}
              alt={ReactHtmlParser(title) + "圖片"}
              onError={() => {
                this.setState({ hasPic: false });
              }}
            />
          )}
        </li>
      </>
    );
  }
}

DBDisplayComp2.propTypes = {
  /**
   * The layout define display config is used to define layout.
   * The datasoure is from LayoutReturnResult.display.
   */
  displayConfig: PropTypes.array.isRequired,

  /** td content */
  data: PropTypes.array,

  /** layout define's func, record link or button behavior. */
  functionConfigList: PropTypes.array,

  /** layout define's func_right, record link or button behavior. */
  functionRightConfigList: PropTypes.array,

  /** layout define's left_right, record link or button behavior. */
  functionLeftConfigList: PropTypes.array,

  /** layout define's detail */
  detailList: PropTypes.object,

  /** button events */
  buttonEvent: PropTypes.func,

  /**
   * batch config
   */
  batchConfig: PropTypes.array,

  /**
   * serialNo
   */
  serialNo: PropTypes.number,

  /**
   * checked the row or not;
   */
  checked: PropTypes.bool,

  /**
   * row style className
   */
  rowStyle: PropTypes.string,
};

DBDisplayComp2.defaultProps = {
  buttonEvent: () => {},
  functionConfigList: [],
  functionRightConfigList: [],
  functionLeftConfigList: [],
  detailList: [],
  batchConfig: [],
  serialNo: -1,
  checked: false,
  rowStyle: "",
};

export default DBDisplayComp2;
